import { ColorsScore } from '@/ui/theme/colors-score';

export type ScoreColor = {
  text: string;
  main: string;
  secondary: string;
};

export function getColorForScore(score: string): ScoreColor {
  switch (score) {
    case 'A':
      return ColorsScore.A;
    case 'B':
      return ColorsScore.B;
    case 'C':
      return ColorsScore.C;
    case 'D':
      return ColorsScore.D;
    case 'E':
      return ColorsScore.E;
    default: {
      return ColorsScore.none;
    }
  }
}

export function getColorScaleForScore(score: string): string[] {
  switch (score) {
    case 'A':
      return ['#24A831', '#2BCA3B', '#41D650', '#68DF73', '#89E692'];
    case 'B':
      return ['#96B715', '#A5C918', '#B4DB1A', '#CBEA4E', '#DFF291'];
    case 'C':
      return ['#C98E18', '#E5A524', '#EAB54E', '#F0CA7F', '#F4D9A4'];
    case 'D':
      return ['#EF4F1A', '#F26D40', '#F4805B', '#F7A78D', '#FAC4B3'];
    case 'E':
      return ['#B81C64', '#DF2A7F', '#E75F9F', '#EC83B4', '#F1A7CA'];
    default: {
      return ['#3A56A5', '#6882CA', '#A4B4DF'];
    }
  }
}
